import type { StatusOption } from './types.js';

/**
 * Sprint ordering is derived from the monday column's own label order (index), falling back to the
 * first number embedded in the label, then alphabetical. Nothing here knows specific sprint names.
 */
export function orderSprints(labels: Array<{ label: string; index?: number }>): string[] {
  const num = (s: string): number | null => {
    const m = /(\d+)/.exec(s);
    return m ? Number(m[1]) : null;
  };
  return [...labels]
    .sort((a, b) => {
      if (a.index != null && b.index != null && a.index !== b.index) return a.index - b.index;
      const na = num(a.label);
      const nb = num(b.label);
      if (na != null && nb != null && na !== nb) return na - nb;
      return a.label.localeCompare(b.label);
    })
    .map((l) => l.label);
}

export function orderedSprintLabels(options: StatusOption[]): string[] {
  return orderSprints(options);
}

/** Interpolate light -> mid blue across the ordered sprints; recompute whenever sprints change. */
export function sprintColorScale(ordered: string[]): Record<string, { bg: string; fg: string }> {
  const out: Record<string, { bg: string; fg: string }> = {};
  const n = ordered.length;
  ordered.forEach((label, i) => {
    const t = n <= 1 ? 0.5 : i / (n - 1);
    const lightness = 78 - t * 30; // 78% (light) -> 48% (mid)
    const saturation = 70 + t * 10;
    const hue = 205 + t * 15;
    out[label] = {
      bg: `hsl(${hue.toFixed(0)} ${saturation.toFixed(0)}% ${lightness.toFixed(0)}%)`,
      fg: lightness > 62 ? '#0b1b2e' : '#f4f8ff',
    };
  });
  return out;
}
